export default Object.freeze({
  ORDINARIA: 10,
  MORATORIA: 20
})
